import Vue from 'vue';
import '@inkline/inkline/src/inkline.scss';
import {
  Inkline,
} from '@inkline/inkline/src';
import * as components from '@inkline/inkline/src/components';

Vue.use(Inkline, { components });
